/**
 * Active city dataset — tiny module so decision surfaces that don't
 * already receive a dataset (the verdict popup, for instance) can resolve
 * the current city's verdict list on demand.
 *
 * Populated once per city install by `main-simple.ts`. Pure accessor —
 * no scoring, no side effects beyond the set.
 */

import type { Verdict } from "../data/verdicts";

let current: readonly Verdict[] | null = null;

export function setActiveDataset(ds: readonly Verdict[]): void {
  current = ds;
}

export function getActiveDataset(): readonly Verdict[] | null {
  return current;
}
